
<!-- 计费设置 -->
<template>
    <div class="container containerBox">
        <cmp-charge 
            :form="schemeInfo"
            @onSave="onSaveCharge"
            ></cmp-charge>
    </div>
</template>

<script>
import Service from '@/api/Service'
import CmpCharge from '@/components/CmpChargeScheme/CmpCharge'
export default {
    name: 'chargeset',
    data () {
        return {
            schemeId: '',
            schemeInfo: {},
        };
    },
    components: {
        CmpCharge
    },
    created() {
        this.schemeId = this.$route.params.schemeId;
        this.getData(this.schemeId);
    },
    methods: {
        // 获取计费方案明细
        async getData(oid) {
            let data = await Service.getChargeSchemeInfo({OID : oid});
            if(data) {
                this.schemeInfo = data;
            }
        },
        // 保存计费设置
        async onSaveCharge(params) {
            let data = await Service.editScheme_charge(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                });
                this.$router.push('/setchargescheme')
            }
        },
    }
}

</script>
<style lang='css' scoped>
</style>